const zhCT = {
  '上传': '上載'
}

export default zhCT